
export const MediaTypeDropdown = ({ value, onChange }) =>
{
  return (
    <select value={value} onChange={e=>onChange(e.target.value)}>
      <option value="">全部</option>
      <option value="email">電郵</option>
      <option value="whatsapp">WhatsApp</option>
    </select>
  );
}

export default MediaTypeDropdown;
